import type { PageGuide } from "../page-guide.js";

/**
 * Help guide for Ideation Maps. The maps page does not yet expose panel-level
 * help anchors, so the first-run tour is a centred workflow guide.
 */
export const ideationMapsGuide: PageGuide = {
  route: "/ideation/maps",
  version: 1,
  overviewArticleId: "ideation-maps-overview",
  steps: [
    {
      id: "choose-map",
      title: "Choose the map shape",
      body: "Jump to… (Ctrl+K): type a map name to open it, or search Atlas / maps / hub for the Atlas hub. Then pick hubs for indexes, graph maps for networks, flow maps for ordered relationships, and freestyle maps for early structure.",
    },
    {
      id: "capture-node",
      title: "Capture shared identities",
      body: "A node is one reusable identity that can appear in many maps. Give it a stable label, a useful kind, a short summary, and durable context.",
    },
    {
      id: "connect",
      title: "Connect with typed relationships",
      body: "Use relationship labels such as depends-on, implements, references, questions, addresses, or supersedes so the map explains why nodes relate.",
    },
    {
      id: "documents",
      title: "Attach evidence",
      body: "Attach Vault documents to the node they support. Keep raw files in Vault/Blob and use node context for the extracted, reviewed meaning.",
    },
    {
      id: "review-ai",
      title: "Review AI proposals",
      body: "Claude can help extract nodes, edges, and context additions, but every proposed change must be accepted, edited, or rejected before it is applied.",
    },
  ],
  panels: [],
  guidedActions: [],
};
